import { render } from "./MoreBtn.vue?vue&type=template&id=af3f5af8&scoped=true"
import script from "./MoreBtn.vue?vue&type=script&lang=js"
export * from "./MoreBtn.vue?vue&type=script&lang=js"

import "./MoreBtn.vue?vue&type=style&index=0&id=af3f5af8&lang=scss&scoped=true"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3f5af8"]])

export default __exports__